<template>
<div class="btnwrapper">
  <a href="#" class="close-button no-deco" @click="$emit('close')">
    <div class="in">
      <div class="close-button-block"></div>
      <div class="close-button-block"></div>
    </div>
    <div class="out">
      <div class="close-button-block"></div>
      <div class="close-button-block"></div>
    </div>
  </a>
</div>

</template>

<script>
export default {
  name: 'RTCloseButton',
  data: function() {
    return {
    };
  },
};
</script>
<style scoped>

/*
.btnwrapper {
  width: 100vw;
  height: 100vh;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-pack: center;
          justify-content: center;
}
*/

.close-button {
  display: block;
  width: 40px;
  height: 40px;
  position: relative;
  overflow: hidden;
}
.close-button > div {
  position: relative;
}
.close-button-block {
  width: 40px;
  height: 20px;
  position: relative;
  overflow: hidden;
}
.close-button-block:before, .close-button-block:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: calc(55% - 4px);
  display: block;
  width: 4px;
  height: 25px;
  -webkit-transform-origin: bottom center;
          transform-origin: bottom center;
  background: black;
  -webkit-transition: all ease-out 280ms;
  transition: all ease-out 280ms;
}
.close-button-block:last-of-type {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}
.close-button .in .close-button-block:before {
  -webkit-transition-delay: 280ms;
          transition-delay: 280ms;
  -webkit-transform: translateX(20px) translateY(-20px) rotate(45deg);
          transform: translateX(20px) translateY(-20px) rotate(45deg);
}
.close-button .in .close-button-block:after {
  -webkit-transition-delay: 280ms;
          transition-delay: 280ms;
  -webkit-transform: translateX(-22px) translateY(-22px) rotate(-45deg);
          transform: translateX(-22px) translateY(-22px) rotate(-45deg);
}
.close-button .out {
  position: absolute;
  top: 0;
  left: 0;
}
.close-button .out .close-button-block:before {
  -webkit-transform: translateX(-5px) translateY(5px) rotate(45deg);
          transform: translateX(-5px) translateY(5px) rotate(45deg);
}
.close-button .out .close-button-block:after {
  -webkit-transform: translateX(5px) translateY(5px) rotate(-45deg);
          transform: translateX(5px) translateY(5px) rotate(-45deg);
}
.close-button:hover .in .close-button-block:before {
  -webkit-transform: translateX(-5px) translateY(5px) rotate(45deg);
          transform: translateX(-5px) translateY(5px) rotate(45deg);
}
.close-button:hover .in .close-button-block:after {
  -webkit-transform: translateX(5px) translateY(5px) rotate(-45deg);
          transform: translateX(5px) translateY(5px) rotate(-45deg);
}
.close-button:hover .out .close-button-block:before {
  -webkit-transform: translateX(-20px) translateY(20px) rotate(45deg);
          transform: translateX(-20px) translateY(20px) rotate(45deg);
}
.close-button:hover .out .close-button-block:after {
  -webkit-transform: translateX(20px) translateY(20px) rotate(-45deg);
          transform: translateX(20px) translateY(20px) rotate(-45deg);
}

</style>